import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Config } from '@shared/configs/config';

@Pipe({name: 'dateFormat', pure: true})

export class DateFormatPipe implements PipeTransform {
  transform(value: string, format?: string): string {
    return value ? moment(value, Config.DATE_SERVER).format(format ? format : Config.DATE_FORMAT_DOTS) : '';
  }
}
